<template>
  <div class="content">
    <pic-nav></pic-nav>
    <slider-menu :menuData="menuData" hasBackground></slider-menu>
  </div>
</template>

<script>
import picNav from "@/components/Nav";
import sliderMenu from "@/components/SliderMenu";

export default {
  components: { picNav, sliderMenu },
  data() {
    return {
      menuData: [
        {
          path: "/pc/exportCenter/index",
          icon: "",
          title: "导出列表",
        }
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/exportCenter/index.vue